import panelRoot from './panelRoot';
import panelTitle from './panelTitle';
import panelBody from './panelBody';
import panelItem from './panelItem';
import status from './status';
import iconArrowThinRight from './iconArrowThinRight';

const styles = (theme) => ({
  collapsed: {},
  iconArrowThinRight: iconArrowThinRight(theme),
  panelBody: panelBody(theme),
  panelItem: panelItem(theme),
  panelTitle: panelTitle(theme),
  root: panelRoot(theme),
  status: status(theme),
  verifyDepositsLink: {},
});

export default styles;
